import React, { useState, useEffect, useContext, createRef } from 'react'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

import { dateDisplayFormat, dateOnlyDisplayFormat, dateValueFormat } from '../../utils'
import { Alert, Checkbox, CustomTooltip } from '../ui_new'
import { AdminFeatureWrapper } from '../utils/AdminFeatureWrapper'
import ActionsDropdown from '../UI/ActionsDropdown'
import { Delete, MoreVert, OpenInNew } from '@mui/icons-material';
import { Signature, Download, MoveToFolder, Pen, Duplicate, RegisteredMail, OpenDocument, History, Share, ValidationMode, CheckCircle, Close } from '../../assets/icons';
import { Archive } from '@material-ui/icons'
import { useAgencyActions, useDocumentsActions, useSingleDocumentActions } from '../../hooks'
import { DocumentsContext, UserContext, DocumentsFoldersContext, LoaderContext, RegisteredMailContext, ValidationContext } from '../../context'
import { MoveSelectedItemsToFolderModal, SingleDocumentHistory } from '.'
import SingleDocumentSignVialink from './SingleDocumentSignVialink'
import { fetch_document_events, fetch_document_history } from '../../services/firestore'


const TodoActionBox = ({ id, task, type = 'task' }) => {
  const { user } = useContext(UserContext)
  const [checked, setChecked] = useState(false)
  const [createdAt, setCreatedAt] = useState('');
  const history = useHistory()
  const { getDocumentHistory, getDocumentEventsDayArray } = useSingleDocumentActions()
  const { setSendModalDefaultAttachments, setShowRegisteredMailSendModal, createAr24MailRequestFromDocument } = useContext(RegisteredMailContext)
  const [showMoveToFolderModal, setShowMoveToFolderModal] = useState(false)
  const { docFolders } = useContext(DocumentsFoldersContext)
  const { templates, getTemplateById, getDocumentById, documents } = useContext(DocumentsContext);
  const { setLoading, setShowGlobalResponseLoader, setGlobalResponseLoaderText } = useContext(LoaderContext)
  const { promptResolveValidation, resolveValidation } = useContext(ValidationContext)
  const { progress, getPreviewData, duplicateDocument } = useSingleDocumentActions()
  const { isTemplateValidationRequired } = useAgencyActions()
  const [showDeleteAlert, setShowDeleteAlert] = useState(false)
  const [signModal, setSignModal] = useState({
    isOpen: false,
    document: null,
    template: null,
    contacts: []
  })
  const [docHistory, setDocHistory] = useState([])
  const [docEvents, setDocEvents] = useState([])
  const [showHistoryModal, setShowHistoryModal] = useState(false)

  const [taskDocument, setTaskDocument] = useState(null)
  const [taskTemplate, setTaskTemplate] = useState(null)

  const actionDropdownRef = createRef()

  useEffect(() => {
    const document = getDocumentById(task.documentId)
    if(!document) return
    setTaskDocument(document)
    const template = getTemplateById(document.template)
    if(!template) return
    setTaskTemplate(template)
  }, [documents, templates, task, getDocumentById, getTemplateById])

  const handleGoTo = () => {
    if(task.status === 'pending') {
      // setShowDropdown(false)
      history.push(`/documents/${task.documentId}?validation`)
    } else {
      history.push(`/documents/${task.documentId}`)
    }
    actionDropdownRef.current.close()
  }

  const handleEditDocument = () => {
    // setShowDropdown(false)
    actionDropdownRef.current.close()
    history.push(`/documents/${task.documentId}`)
  }

  const handleShareDocument = () => {
    // setShowDropdown(false)
    actionDropdownRef.current.close()
    history.push(`/documents/${task.documentId}?share`)
  }

  const handleOpenValidationMode = () => {
    // setShowDropdown(false)
    actionDropdownRef.current.close()
    history.push(`/documents/${task.documentId}?validation`)
  }

  const handleCancelTask = () => {
    // setShowDropdown(false)
    actionDropdownRef.current.close()
    resolveValidation(task, 'cancel')
  }

  const handleValidate = () => {
    // setShowDropdown(false)
    actionDropdownRef.current.close()
    promptResolveValidation(task, 'validate')
  }

  const handleRefuse = () => {
    // setShowDropdown(false)
    actionDropdownRef.current.close()
    promptResolveValidation(task, 'refuse')
  }

  const isPastDeadline = (task.status === 'pending' || task.status === 'refused') && task.deadline && moment(task.deadline).isBefore(moment(), 'day')
  const badgeType = 
    type === 'event' ? '' :
    (task.status === 'pending' || task.status === 'refused') ?
      isPastDeadline ? 'past-deadline' : '' :
    task.status === 'validated' ?
      taskDocument?.status || '' : // completed, signature-requested, signed, lre-sent
    ''

  const badgeText =
    badgeType === 'past-deadline' ? 'En retard' :
    badgeType === 'draft' ? 'Brouillon' :
    badgeType === 'ready' ? 'Complété' :
    badgeType === 'completed' ? 'Complété' :
    badgeType === 'signature-requested' ? 'Envoyé à signer' :
    badgeType === 'signed' ? 'Signé' :
    badgeType === 'lre_sent' ? 'Envoyé par LRE' :
    badgeType === 'to_sign' ? 'À signer' :
    taskDocument?.status || ''
  
  const badgeColor =
    badgeType === 'past-deadline' ? 'red' :
    'white'

  
  
  const handleCloseHistoryModal = () => {
    setShowHistoryModal(false)
  }

  const handleViewHistory = async () => {
    // setShowDropdown(false)
    actionDropdownRef.current?.close()
    
    setShowGlobalResponseLoader(true)
    setGlobalResponseLoaderText('Télécharger l\'historique du document')
    await handleFetchDocumentHistory(task.documentId)
    setShowGlobalResponseLoader(false)
    setGlobalResponseLoaderText('')
    setShowHistoryModal(true)
  }
  
  const handleFetchDocumentHistory = async (documentId) => {
    
    const fetchHistory = async (id, doc) => {
      try {
        const res = await fetch_document_history(id)
        const arr = getDocumentHistory(res)
        setDocHistory(arr)
      } catch (err) {
        console.log(err)
      }
    }

    const fetchEvents = async (id) => {
      try {
        const res = await fetch_document_events(id)
        const arr = getDocumentEventsDayArray(res)
        setDocEvents(arr)
      } catch (err) {
        setDocEvents([])
        console.log(err)
      }
    }

    await fetchHistory(documentId)
    await fetchEvents(documentId)
  }

  const handleRestoreDocumentVersion = async (version) => {
    // console.log('handleRestoreDocumentVersion', version)
  }

  const submittedDateForTask = (task) => {
    const submittedValidator = task.validators.find(v => v.submitted)
    if(!submittedValidator) return null
    return moment(submittedValidator.submitted).format('DD/MM/YYYY HH:mm')
  }  

  return (
    <div className={`todo-action-box ${type} ${type === 'task' && isPastDeadline ? 'past-deadline' : ''}`}>
      <div className={`todo-action-box__check ${checked ? 'checked' : ''}`}>
        <button className="icon-btn icon-btn--svg-xl" onClick={handleGoTo}><span className="svg-icon"><OpenInNew /></span></button>
        <ActionsDropdown
          trigger={
            <button 
              className="icon-btn icon-btn--ghost icon-btn--svg-xl more-vert-icon" 
              // onClick={() => setShowDropdown(!showDropdown)}
              >
              <span className="svg-icon"><MoreVert fontSize='medium' /></span>
            </button>
          }
          hideHeader
          width={120}
          dropdownClass="actions-dropdown--no-padding"
          ref={actionDropdownRef}
        >
          <div className='dashboard-column__dropdown'>
            <ul>
              <li onClick={handleEditDocument} className="edit"><span className="icon"><Pen /></span>Editer le document</li>
              <li onClick={handleShareDocument} className="edit"><span className="icon"><Share /></span>Partager</li>
              <li onClick={handleViewHistory} className="edit"><span className="icon"><History /></span>Historique</li>
            </ul>
            <ul>
              <li onClick={handleOpenValidationMode} className="edit"><span className="icon"><ValidationMode /></span>Mode révision</li>
            </ul>
            {(user.validation_access === 'manager' || user.validation_access === 'negotiator') && <ul>
              {(task.status === 'pending' || task.status === 'refused') && <li onClick={handleCancelTask} className='duplicate'><span className="icon"><Duplicate /></span>Annuler la tâche</li> }
            </ul>}
            {user.validation_access === 'manager' && <ul>
              {(task.status === 'pending' || task.status === 'refused') &&
                <li className='success' onClick={handleValidate}>
                  <span className="icon"><CheckCircle /></span>
                  Valider le document
                </li>}
              {task.status === 'pending' &&
                <li className='trash' onClick={handleRefuse}>                      
                  <span className="icon"><Close /></span>
                  Refuser le document
                </li>}
            </ul>}
          </div>
        </ActionsDropdown>
      </div>
      <CustomTooltip content={documents[task.documentId]?.name || task.documentName}>
        <div className="todo-action-box__go-to" onClick={handleGoTo}></div>
      </CustomTooltip>

      <div className="todo-action-box__content">
        <div className='flex flex-row justify-between items-center w-full'>
          {<h3>{documents[task.documentId]?.name || task.documentName}</h3>}
          {badgeType ? (
            <span className={`todo-action-box__badge ${badgeColor}`}>
              {badgeText}
            </span>
          ) : (
            <span />
          )}
        </div>

        {/* <div> */}
          {/* <h3>{`${doc.to_firstname} ${doc.to_lastname.toUpperCase()}`}</h3> */}
          {/* {doc.document_name && <p className="mail-box-label">{doc.document_name}</p>} */}

        {/* </div> */}
        <div>
          {type === 'task' && task.deadline && task.status !== 'validated' &&
            <h4 className="date">À valider pour le {moment(task.deadline).format(dateValueFormat)}</h4>
          }
          {type === 'task' && (task.status === 'validated' || task.status === 'refused') && (
            <h4 className="date">{submittedDateForTask(task)}</h4>
          )}
          {type === 'event' && task.date &&
            <h4 className="date">{moment(task.date).format(dateDisplayFormat)}</h4>
          }
        </div>
        {type === 'task' && taskTemplate && <div className="todo-action-box__meta">
          <div className="date">{isTemplateValidationRequired(taskTemplate.id) ? 'Obligatoire' : 'Facultatif'}</div>
        </div>}
        {type === 'event' && task.comment && <div className="todo-action-box__meta">
          <div className="date">{task.comment}</div>
        </div>}
      </div>

      {showHistoryModal && (
        <SingleDocumentHistory
            onClose={handleCloseHistoryModal}
            docHistory={docHistory}
            docEvents={docEvents}
            onRestore={handleRestoreDocumentVersion}
        />
      )}

    </div>
  )
}

export default TodoActionBox